"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var ToolbarWrapper = (0, material_1.styled)(material_1.Toolbar)(function (_a) {
    var theme = _a.theme;
    return ({
        minHeight: theme.spacing(7),
        height: theme.spacing(7),
        '.showOnHover': {
            opacity: 0,
            transition: 'opacity 250ms ease 0s',
        },
        ':hover': {
            '.showOnHover': { opacity: 1 },
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(ToolbarWrapper, {
    disableGutters: true,
});
